import { ScrollArea as ScrollAreaPrimitive } from 'radix-ui';
import type { ComponentProps } from 'react';

export const ScrollArea = ScrollAreaPrimitive.Root;
export const ScrollAreaViewport = ScrollAreaPrimitive.Viewport;
export const ScrollAreaScrollbar = ScrollAreaPrimitive.Scrollbar;
export const ScrollAreaThumb = ScrollAreaPrimitive.Thumb;
export const ScrollAreaCorner = ScrollAreaPrimitive.Corner;

export type ScrollAreaProps = ComponentProps<typeof ScrollAreaPrimitive.Root>;
export type ScrollAreaViewportProps = ComponentProps<typeof ScrollAreaPrimitive.Viewport>;
export type ScrollAreaScrollbarProps = ComponentProps<typeof ScrollAreaPrimitive.Scrollbar>;
export type ScrollAreaThumbProps = ComponentProps<typeof ScrollAreaPrimitive.Thumb>;
export type ScrollAreaCornerProps = ComponentProps<typeof ScrollAreaPrimitive.Corner>;
